package one.healthium.log_period.ui.utils

import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.Month
import kotlinx.datetime.YearMonth
import one.healthium.base.utils.localizedName

internal fun YearMonth.displayText(short: Boolean = false): String {
    return "${month.displayText(short = short)} $year"
}

internal fun Month.displayText(short: Boolean = true): String =
    localizedName(abbreviated = short)

internal fun DayOfWeek.displayText(uppercase: Boolean = false, narrow: Boolean = false): String =
    localizedName(abbreviated = false, uppercase = uppercase, narrow = narrow)
